import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		padding: `${THEME.spacing.lg}px ${THEME.spacing.lg}px 0 ${THEME.spacing.lg}px`,
	},
	header: {
		marginBottom: THEME.spacing.xl,
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	headerTitle: {
		color: THEME.colors.text.main,
	},
	body: {
		display: 'flex',
		flexDirection: 'column',
	},
	section: {
		marginBottom: THEME.spacing.xl,
	},
	sectionTitle: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.lg,
		marginBottom: THEME.spacing.md,
	},
	draftsSectionTitle: {
		// Additional styling for "Not Yet Published" section if needed
	},
	errorBanner: {
		padding: THEME.spacing.lg,
		backgroundColor: THEME.colors.danger.light,
		border: `1px solid ${THEME.colors.danger.main}`,
		borderRadius: THEME.common.borderRadius,
		marginTop: THEME.spacing.lg,
	},
});
